import { Injectable, inject } from '@angular/core'
import { ConfirmationModalComponent } from '../../components/misc/confirmation-modal/confirmation-modal.component'
import { DynamicRefService } from '../dynamic-ref-service/dynamic-ref.service'
import type { ConfirmModalOptions } from './types'

@Injectable({
  providedIn: 'root'
})
export class SharedModalService {
  private dynamicRefService = inject(DynamicRefService)

  /**
   * Show the confirmation modal component
   * @param {ConfirmModalOptions} options
   * @returns {ConfirmationModalComponent}
   */
  showConfirm(options: ConfirmModalOptions): ConfirmationModalComponent {
    const [ref, modal] = this.dynamicRefService.create(ConfirmationModalComponent, { destroyOnHide: true })

    Object.keys(options).forEach(key => {
      ref.setInput(key, options[key])
    })

    return modal
  }
}
